import './index_mWeb.css';
import { Key, useEffect, useState } from 'react';
import { useRouteLocation, useLink } from 'react-router-stack';
import { HeaderWithTimer, RouteWrapper, ScreenImageBackground, View } from '../../../component';
import { getTeamPreviewPlayer } from '../../../utilities/helper';
import { TeamPreviewPlayerHeader } from '../../component';
import Constants from '../../../constants';
import TeamPreviewHeaderMWeb from '../../component/team_preview_header/index_mWeb';
import TeamPreviewPlayerRowMWeb from '../../component/team_preview_player_row/index_mWeb';
const TeamPreviewMWeb = () => {
  const { state = {} } = useRouteLocation();
  const [teamPreviewData, setTeamPreviewData] = useState({
    userTeamScore: 0,
    sectionPlayerList: []
  } as any);

  const [lineupsOut, setLineupsOut] = useState(false);

  const {
    teamData = {},
    item: matchItem = {},
    completed = false,

    matchAllPlayersList = [],
    gameType = ''
  } = state;

  const { teamA = {}, teamB = {} } = matchItem;

  const {
    players = [],
    captainId = '',
    viceCaptainId = '',
    teamNumber = 1,
    username = ''
  } = teamData;

  useEffect(() => {
    if (!completed) {
      let playingPlayersList = [];
      playingPlayersList = matchAllPlayersList.filter(
        (player: { playingEleven: boolean }) => player.playingEleven === true
      );
      setLineupsOut(playingPlayersList.length >= 15);
    }

    setTeamPreviewData(() =>
      getTeamPreviewPlayer({
        players,
        matchAllPlayersList,
        teamA,
        teamB,
        captainId,
        viceCaptainId,
        gameType
      })
    );
  }, []);

  const navigate = useLink();

  const renderItemPlayers = (item: any) => {
    return (
      <TeamPreviewPlayerRowMWeb
        key={item.id}
        item={item}
        completed={completed}
        lineupsOut={lineupsOut}
        isTeamTeamA={teamA?.teamId === item?.teamId ? true : false}
      />
    );
  };

  const renderList = (list = []) => {
    return <View className="team-preview-list-container_mWeb">{list.map(renderItemPlayers)}</View>;
  };

  const onPressBack = () => {
    try {
      navigate.goBackView();
    } catch (err) {
      navigate.go(-1);
    }
  };

  const renderTeamPreview = (item: { title: Key | null | undefined; data: any }, index: any) => {
    return (
      <View className={'team-preview-list-wrapper_mWeb'} key={item + index}>
        <TeamPreviewPlayerHeader key={item.title} title={item.title} />
        {renderList(item.data)}
      </View>
    );
  };
  const onCalledDeadline = () => {
    navigate.push('/', { replace: true });
  };
  return (
    <RouteWrapper>
      <ScreenImageBackground
        source={
          gameType === Constants.GameType.FANTASY_FOOTBALL
            ? Constants.Images.FootballBackground
            : Constants.Images.CricketBackground
        }>
        <HeaderWithTimer
          onlyTitle={true}
          onPressBack={onPressBack}
          matchItem={matchItem}
          onCalledDeadline={onCalledDeadline}
          //   gameName={gameName}
        />
        <View className={'team-preview-container_mWeb '}>
          <TeamPreviewHeaderMWeb
            username={username}
            teamA={teamA}
            teamB={teamB}
            teamNumber={teamNumber}
            userTeamScore={teamPreviewData['userTeamScore']}
            completed={completed}
          />
          {teamPreviewData['sectionPlayerList'].map(renderTeamPreview)}
        </View>
      </ScreenImageBackground>
    </RouteWrapper>
  );
};
export default TeamPreviewMWeb;
